import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Result } from 'antd';
import { PrimaryButton } from '../button';
import { jsx as _jsx } from "react/jsx-runtime";
export var ServerError = function ServerError(props) {
  var onBackToHomeClick = props.onBackToHomeClick,
      extra = props.extra;
  return /*#__PURE__*/_jsx(Result, _objectSpread(_objectSpread({}, props), {}, {
    status: "500",
    title: "500",
    subTitle: "Sorry, something wrong in server!!!",
    extra: extra !== null && extra !== void 0 ? extra : /*#__PURE__*/_jsx(PrimaryButton, {
      onClick: function onClick() {
        return onBackToHomeClick;
      },
      children: "Back Home"
    })
  }));
};